// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"6d1d16a2","766":"3345ea15"}[chunkId] + ".chunk.css";
};